<template>
  <div v-if="complaint">
    <div>
      <!-- Action Buttons Section -->
      <div class="flex sm:flex-row flex-col justify-end">
        <div v-if="!complaintIsClosed" class="flex gap-4">
          <SecondaryButton @click="openUpdateModal = true">Mettre à jour</SecondaryButton>
          <SecondaryButton @click="openCloseModal = true">Clôturer la réclamation</SecondaryButton>
        </div>
      </div>
    </div>

    <div class="mt-6">
      <div class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
        <span :class="['px-4 py-1 rounded-lg font-bold text-sm absolute top-4 right-4', statusStyle(complaint.status)]">
          {{ $t("complaints.status." + complaint.status) }}
        </span>

        <h2 class="text-xl font-bold text-center mt-6 mb-8">{{ complaint.friendlyId }}</h2>

        <div class="flex flex-col md:flex-row">
          <div class="flex-1 pr-0 md:pr-8">
            <div class="space-y-1">
              <FieldRow label="Contrat">
                <span
                  class="font-light text-primary hover:text-primary-dark cursor-pointer"
                  @click="goToPlanSaleDetails"
                >
                  {{ complaint.planSaleFriendlyId }}
                </span>
              </FieldRow>
              <FieldRow label="Thème" :value="$t(`complaints.theme.${complaint.theme}`)" />
              <FieldRow label="Sous-thème" :value="$t(`complaints.subtheme.${complaint.subtheme}`)" />
              <FieldRow label="Canal" :value="$t(`complaints.channel.${complaint.channel}`)" />
              <FieldRow label="Sujet" :value="complaint.subject" />
              <FieldRow label="Détails" :value="complaint.details" />
              <FieldRow label="Date de réception" :value="complaint.receptionDate" />
              <FieldRow label="Créé par" :value="$t(`complaints.created_by.${complaint.createdBy}`)" />
            </div>
          </div>

          <div class="hidden md:block border-l-2 border-dotted border-gray-300 mx-6"></div>

          <div class="flex-1 pt-8 md:pt-0 md:pl-8">
            <div class="space-y-1">
              <FieldRow label="Date d'envoi de l'AR" :value="complaint.acknowledgementSentDate" />
              <FieldRow label="Montant demandé" :value="formatPrice(complaint.requestedAmount)" />
              <FieldRow label="Montant remboursé" :value="formatPrice(complaint.reimbursedAmount)" />
              <FieldRow label="Date de réponse" :value="complaint.responseDate" />
              <FieldRow label="Nature de la réponse" :value="complaint.responseNature" />
              <FieldRow label="Notes de résolution" :value="complaint.resolutionNotes" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <UpdateModal
      :open="openUpdateModal"
      :complaint="complaint"
      @close="openUpdateModal = false"
      @updated="fetchComplaint"
    />
    <CloseModal
      :open="openCloseModal"
      :complaint="complaint"
      @close="openCloseModal = false"
      @updated="fetchComplaint"
    />
  </div>
  <div v-else>
    <Loading />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { FieldRow, Loading, SecondaryButton, formatPrice } from "@estaly/ui";
import UpdateModal from "@/components/complaints/UpdateModal.vue";
import CloseModal from "@/components/complaints/CloseModal.vue";

export default {
  components: { FieldRow, Loading, SecondaryButton, UpdateModal, CloseModal },
  data: () => {
    return {
      complaint: null,
      openUpdateModal: false,
      openCloseModal: false,
    };
  },

  async beforeMount() {
    await this.fetchComplaint();
  },

  computed: {
    ...mapGetters("complaints", ["statusStyle", "isClosed"]),
    complaintIsClosed() {
      return this.isClosed(this.complaint);
    },

    complaintId() {
      return this.$route.params.id;
    },
  },

  methods: {
    ...mapActions("complaints", ["fetch"]),
    formatPrice,

    async fetchComplaint() {
      this.complaint = await this.fetch({ id: this.complaintId });
    },

    goToPlanSaleDetails() {
      this.$router.push(`/plan-sales/${this.complaint.planSaleFriendlyId}`);
    },
  },
};
</script>
